export * from './ArticleText';
